import { Container, Main, Title } from '@/components/container';
import Layout from '@/components/layout/index';
import Markdown from '@/components/markdown';
import { graphql } from 'gatsby';
import React from 'react';
import styled from 'styled-components';

type Props = {
  data: GatsbyTypes.AboutQuery;
};
const AboutContainer = styled(Container)`
  grid-template:
    'title' 4rem
    'main' auto / auto;
`;
const AboutPage: React.FC<Props> = ({ data }) => (
  <Layout type="about" desc="about me" siteMetadata={data.site.siteMetadata}>
    <AboutContainer>
      <Title>自己紹介 / My Profile</Title>
      <Main>
        <Markdown>
          <h2>長島康生 / NAGASHIMA Koki</h2>
          <ul>
            <li>2000/10/7 生まれ</li>
            <li>慶應義塾大学環境情報学部3年 / a junior in Keio university</li>
          </ul>
          <h2>Technical Skills</h2>
          <h3>Visual tool</h3>
          Processing / Nannou / openFrameworks / WebGL / GLSL
          <h3>3D Modeling etc.</h3>
          Blender / 3D-Coat
          <h3>Game Engine</h3>
          Unity / Godot Engine / UE4
          <h3>Other Programming Lang.</h3>
          Python / C++ / Node.js / R / Rust
        </Markdown>
      </Main>
    </AboutContainer>
  </Layout>
);

export const query = graphql`
  query About {
    site {
      siteMetadata {
        title
        siteUrl
        description
      }
    }
  }
`;

export default AboutPage;
